/* KALCODE story — shared motion engine (guarded so it runs once) */
(function () {
  if (window.__kalStory) return; window.__kalStory = true;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SHAPES = ['circle', 'square', 'triangle', 'rect', 'hexagon', 'diamond', 'pentagon', 'star'];

  function shuffle(a) { a = a.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  function setShape(el, name) {
    if (el.dataset.shape === name) return;
    SHAPES.forEach(function (s) { el.classList.remove('shape-' + s); });
    el.classList.add('shape-' + name); el.dataset.shape = name;
  }

  /* reversible: elements reveal on the way in and hide again on the way out, so scrolling up replays in reverse */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.target.classList.toggle('in', e.isIntersecting); });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  function bind(root) {
    root = root || document;
    root.querySelectorAll('.rv, [data-reveal]').forEach(function (el) { io.observe(el); });
    root.querySelectorAll('[data-count]').forEach(function (el) { cio.observe(el); });
    root.querySelectorAll('.void__dot').forEach(function (dot) {
      dot.__seq = shuffle(SHAPES);
      setShape(dot, 'circle');
      var stage = dot.parentNode;
      if (!stage.querySelector('.void__sat') && !reduce) {
        var sats = shuffle(SHAPES).slice(0, 7);
        sats.forEach(function (s, i) {
          var el = document.createElement('i'); el.className = 'void__sat shape-' + s;
          el.style.setProperty('--a', (i / sats.length * 360 + Math.random() * 30) + 'deg');
          stage.insertBefore(el, dot);
        });
      }
    });
  }

  /* counters (replay on re-entry) */
  var cio = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var el = e.target;
      if (!e.isIntersecting) { el.textContent = '0'; el.__run = (el.__run || 0) + 1; return; }
      var run = el.__run = (el.__run || 0) + 1;
      var to = parseFloat(el.dataset.count), dec = (String(el.dataset.count).split('.')[1] || '').length;
      if (reduce) { el.textContent = to.toFixed(dec); return; }
      var t0 = performance.now(), dur = 1800;
      (function tick(t) {
        var k = Math.min(1, (t - t0) / dur), ease = 1 - Math.pow(1 - k, 3);
        if (el.__run !== run) return;
        el.textContent = (to * ease).toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        if (k < 1) requestAnimationFrame(tick);
      })(t0);
    });
  }, { threshold: 0.6 });

  /* Tinker/Horizon scrolls .page-wrapper (not window) on desktop — find the real scroller */
  function getScroller() {
    var pw = document.querySelector('.page-wrapper');
    if (pw) { var o = getComputedStyle(pw).overflowY; if ((o === 'auto' || o === 'scroll') && pw.scrollHeight > pw.clientHeight + 1) return pw; }
    return null;
  }
  var scroller = null;
  function scrollPos() { return scroller ? scroller.scrollTop : (window.scrollY || document.documentElement.scrollTop); }
  function scrollMax() { return scroller ? Math.max(1, scroller.scrollHeight - scroller.clientHeight) : Math.max(1, document.documentElement.scrollHeight - innerHeight); }
  function bindScroller() {
    var next = getScroller();
    if (next === scroller) return;
    if (scroller) scroller.removeEventListener('scroll', onScrollRaf);
    scroller = next;
    if (scroller) scroller.addEventListener('scroll', onScrollRaf, { passive: true });
  }

  /* scroll-linked scenes, horizontal tracks, progress bar, floating CTA */
  var scenes = [], bar = null;
  function collect() { scenes = Array.prototype.slice.call(document.querySelectorAll('[data-scene]')); bar = document.querySelector('.story-progress'); bindScroller(); }
  function onScroll() {
    var vh = innerHeight, vw = innerWidth, y = scrollPos();
    scenes.forEach(function (s) {
      var r = s.getBoundingClientRect(), total = r.height - vh;
      var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : (r.top < vh ? 1 : 0);
      s.style.setProperty('--p', p.toFixed(4));
      var dot = s.querySelector('.void__dot');
      if (dot) {
        /* hero phases: 0-.12 dot+shapes, .12-.26 everything fades out, .26-.84 wireframe build, .84-1 final message */
        var cl = function (v) { return Math.min(1, Math.max(0, v)); };
        s.style.setProperty('--fade', cl(1 - (p - 0.12) / 0.14).toFixed(4));
        s.style.setProperty('--q', cl((p - 0.26) / 0.58).toFixed(4));
        s.style.setProperty('--f', cl((p - 0.84) / 0.14).toFixed(4));
        if (dot.__seq && !reduce) {
          var idx = Math.min(dot.__seq.length - 1, Math.floor((p / 0.26) * dot.__seq.length));
          setShape(dot, p < 0.02 ? 'circle' : dot.__seq[idx]);
        }
      }
      var track = s.querySelector('.hs__track');
      if (track) {
        var over = track.scrollWidth - vw;
        track.style.setProperty('--x', (-p * Math.max(0, over)) + 'px');
      }
    });
    if (bar) bar.style.setProperty('--sp', (y / scrollMax()).toFixed(4));
    var f = document.querySelector('[data-fcta]');
    if (f) f.classList.toggle('is-visible', y > vh * (parseFloat(f.dataset.showAfter || 60) / 100));
  }
  document.addEventListener('click', function (e) {
    var f = e.target.closest('[data-fcta]'); if (!f) return;
    if (e.target.closest('[data-fcta-open]')) { f.classList.add('is-open'); var i = f.querySelector('.kai__input'); setTimeout(function () { i && i.focus(); }, 450); }
    else if (e.target.closest('[data-fcta-close]')) f.classList.remove('is-open');
  });
  addEventListener('keydown', function (e) { if (e.key === 'Escape') document.querySelectorAll('[data-fcta].is-open').forEach(function (f) { f.classList.remove('is-open'); }); });
  var ticking = false;
  function onScrollRaf() { if (!ticking) { ticking = true; requestAnimationFrame(function () { onScroll(); ticking = false; }); } }
  addEventListener('scroll', onScrollRaf, { passive: true });
  addEventListener('resize', function () { bindScroller(); onScroll(); });

  function init() { bind(); collect(); onScroll(); }
  document.readyState === 'loading' ? addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); collect(); onScroll(); });
})();
